import { render, staticRenderFns } from "./UserOrderCancel.vue?vue&type=template&id=45c9006d&"
import script from "./UserOrderCancel.vue?vue&type=script&lang=js&"
export * from "./UserOrderCancel.vue?vue&type=script&lang=js&"
import style0 from "./UserOrderCancel.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports